// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".between[data-v-c14dc968] {\n  display: flex;\n}\n.betweenInput[data-v-c14dc968] {\n  width: 150px;\n  margin-right: 10px;\n}\n.betweenBox[data-v-c14dc968] {\n  margin-right: 10px;\n}\n.red[data-v-c14dc968] {\n  color: #f56c6c;\n  margin-right: 4px;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
